export const analyticsData = [
    {
        title: 'PROJECTS DELIVERED',
        number: '+150'
    },
    {
        title: 'SUCCESSFUL REBRANDS',
        number: '4'
    },
    {
        title: 'GLOBAL IMPACTS',
        number: '+1.5M USERS'
    },
    {
        title: 'BUSINESS GROWTH',
        number: '+$500M'
    }
]

export const servicesData = [
    {
      title: 'WEB DEVELOPMENT',
      subtitle: 'Advanced Front-End Solutions',
      description: (
        <>
          I specialize in <strong>developing high-performance websites</strong> with cutting-edge technologies like <strong>React, Framer,</strong> and <strong>WordPress</strong>. My approach ensures:
          
            <p>• Robust CMS integration for efficient content management</p>
            <p>• Seamless user experiences that enhance engagement</p>
            <p>• Optimized performance to drive measurable business success</p>
          
          Your website is not just a digital presence—it's a strategic asset.
        </>
      ),
    },
    {
      title: 'APP DEVELOPMENT',
      subtitle: 'Cross-Platform Mobile Excellence',
      description: (
        <>
          I engineer <strong>versatile mobile applications</strong> using <strong>React Native</strong> to deliver exceptional performance across <strong>iOS</strong> and <strong>Android</strong> platforms. My focus is on:
          
          <p>• Visually compelling and user-friendly designs</p>
          <p>• High security and reliability for a flawless user experience</p>
          <p>• Cross-device compatibility to reach a broader audience</p>
          
          Elevate your mobile strategy with apps that are built to last.
        </>
      ),
    },
    {
      title: 'WEB DESIGN',
      subtitle: 'Bespoke Design for Impact',
      description: (
        <>
          My <strong>bespoke web designs</strong> are tailored to resonate with your brand’s unique identity. Key features include:
          
          <p>• Clean and intuitive layouts for enhanced usability</p>
          <p>• Visually striking elements that engage and convert users</p>
          <p>• Responsive design to ensure a seamless experience on all devices</p>
          
          I create designs that are not just beautiful, but effective in driving results.
        </>
      ),
    },
    {
      title: 'CONTENT & SEO',
      subtitle: 'Strategic Content for Growth',
      description: (
        <>
          I provide <strong>comprehensive content creation</strong> and <strong>SEO services</strong> that boost your online authority. My services include:
          
          <p>• High-quality, optimized content that connects with your audience</p>
          <p>• SEO strategies designed to enhance visibility and drive traffic</p>
          <p>• Sustainable growth through targeted content strategies</p>
          
          Strengthen your brand’s presence with content that speaks to your audience and ranks well.
        </>
      ),
    },
  ];
  